import { CompanySmsSendingRuleRowV2 } from "./CompanySmsSendingRuleRowV2"
import styles from "./CompanySmsSendingRuleV2.module.scss"

import SummaryTextModal from "@/souhl_admin/components/features/companies/sms-sending-rule/SummaryTextModal/SummaryTextModal"
import {
	CompanySmsSendingRuleModalMode,
	companySmsSendingRuleModalMode,
} from "@/souhl_admin/components/features/companies/sms-sending-rule/const"
import {
	FragmentType,
	getFragmentData,
	graphql,
} from "@/souhl_admin/gql/__generated__"

const companySmsSendingRuleV2ViewFragment = graphql(/* GraphQL */ `
	fragment companySmsSendingRuleV2ViewFragment on CompanySmsSendingRuleV2 {
		cancelPolicyTemplateType
		cancelTypeSettings {
			...CompanySmsSendingRuleRowV2Fragment
		}
		companyId
		name
		selectableClaimingConversionPolicyNames
		selectableEncouragingRereservationPolicyNames
		...SummaryTextModalFragment
	}
`)

type Props = {
	fragment: FragmentType<typeof companySmsSendingRuleV2ViewFragment>
	onEditCopyButtonClick?: (
		mode: Extract<
			CompanySmsSendingRuleModalMode,
			| typeof companySmsSendingRuleModalMode.EDIT
			| typeof companySmsSendingRuleModalMode.DUPLICATE_AND_CREATE
		>
	) => void
	onCreate?: () => void
}

const noopEditCopyButtonClick: NonNullable<
	Props["onEditCopyButtonClick"]
> = () => undefined

const CompanySmsSendingRuleV2 = ({
	fragment,
	onEditCopyButtonClick = noopEditCopyButtonClick,
}: Props) => {
	const companySmsSendingRule = getFragmentData(
		companySmsSendingRuleV2ViewFragment,
		fragment
	)

	const cancelTypeSettings = companySmsSendingRule.cancelTypeSettings
	const ruleName = companySmsSendingRule?.name

	return (
		<div className={styles.company_sms_sending_rule}>
			<div className={styles.rule_upper_container}>
				<div className={styles.rule_name}>{ruleName}</div>
				<div className={styles.button_group}>
					<SummaryTextModal fragment={companySmsSendingRule} />
					<button
						className={styles.edit_button}
						onClick={() =>
							onEditCopyButtonClick(companySmsSendingRuleModalMode.EDIT)
						}
						disabled={cancelTypeSettings.length === 0}
					>
						編集
					</button>
					<button
						className={styles.edit_button}
						onClick={() =>
							onEditCopyButtonClick(
								companySmsSendingRuleModalMode.DUPLICATE_AND_CREATE
							)
						}
						disabled={cancelTypeSettings.length === 0}
					>
						複製して新規作成
					</button>
				</div>
			</div>
			<div className={styles.table}>
				<div className={styles.table_header}>
					<div className={styles.corner_header}>キャンセル種別・設定項目</div>
				</div>
				<div className={styles.table_body}>
					{cancelTypeSettings.length === 0 ? (
						<div className={styles.fetch_failed_text}>データはありません。</div>
					) : (
						cancelTypeSettings.map((row, i) => {
							return <CompanySmsSendingRuleRowV2 row={row} key={i} />
						})
					)}
				</div>
			</div>
		</div>
	)
}

export default CompanySmsSendingRuleV2
